import { AddCircle, Delete, Edit, Save } from "@material-ui/icons";
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbar, } from '@mui/x-data-grid-premium';
import { useCallback, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useCreateAccessorialMutation, useDeleteAccessorialListMutation, useGetAccessorialQuery, useGetAllAccessorialQuery, useLazyGetAccessorialDetailsByIDQuery, useUpdateAccessorialListMutation } from "../../../../../features/accessorial/accessorialDetailSlice";
import Dialog from "../../../../designSystem/Dialog";
import errorHandler from "../../../../hooks/ErrorHanlder";
import TextField from "../../../../designSystem/TextField";



const Createaccessorial = () => {
    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm({
        defaultValues: {
            description: '',
            useFuel: '',
            accessorialCode: ''
        }
    });
    const { data: accessorialList, refetch } = useGetAllAccessorialQuery()
    const { data: accessor, refetch: accessorialData } = useGetAccessorialQuery()
    const [addAccessorial] = useCreateAccessorialMutation()
    const [deleteAccessorialList] = useDeleteAccessorialListMutation()
    const [updateAccessorialList] = useUpdateAccessorialListMutation()
    const [getAccessorialDetails] = useLazyGetAccessorialDetailsByIDQuery()
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteId, setDeleteId] = useState()
    const [isShow, setIsShow] = useState(false);
    const [isEdit, setIsEdit] = useState(false)

    const deleteHandler = async () => {
        try {
            await deleteAccessorialList(deleteId);
            toast.success("Accessorial deleted successfully", { position: "top-center" });
            setDeleteDialogOpen(false);
            refetch();
        } catch (error) {
            errorHandler(error)
        }
    };

    const onSubmit = async (values) => {
        try {
            if (isEdit) {
                await updateAccessorialList(values).unwrap();
                setIsEdit(false);
                toast.success("Accessorial Updated Successfully!", {
                    position: "top-center",
                });
            } else {
                await addAccessorial(values).unwrap();
                toast.success("Accessorial Added Successfully", {
                    position: "top-center",
                });
            }

            refetch();
            reset();
            accessorialData();
        } catch (error) {
            errorHandler(error);
        }
    };

    const onCancel = () => {
        setIsEdit(false)
        reset()
    }
    const onClickEdit = useCallback(async (id) => {
        const { data } = await getAccessorialDetails(id).unwrap();
        setValue("accessorialID", data.accessorialID);
        setValue("description", data.description);
        setValue("useFuel", data.useFuel ? "true" : "false");
        setValue("accessorialCode", data.accessorialCode);
        setIsEdit(true);
        setIsShow(true);
    }, [getAccessorialDetails, setValue]);

    const columns = [
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            width: 120,
            renderCell: (data) => {
                const onRemove = (e) => {
                    e.stopPropagation();
                    setDeleteId(data?.id)
                    setDeleteDialogOpen(true);
                };

                return (
                    <>
                        <div className="action_btn">
                            <span className="edit_btn" onClick={(e) => onClickEdit(data.row.id)}><Edit /></span>
                            <span className="del_btn" onClick={onRemove}><Delete /></span>
                        </div>
                        <Dialog title="Delete Confirmation" show={isDeleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} description="Are you sure you want to delete this row?" onSubmit={deleteHandler} />
                    </>
                )

            },
        },
        { field: "accessorialName", headerName: "Accesssorial Name", width: 180 },
        { field: "useFuel", headerName: "Use Fuel", width: 180 },
        { field: "accessorialCode", headerName: "Accessorial Code", width: 180 }
    ];

    const rows = accessorialList?.data.map((data) => {
        return {
            id: data?.accessorialID,
            accessorialName: data?.description,
            useFuel: data?.useFuel,
            accessorialCode: data?.accessorialCode,
        }
    })

    return (
        <>
            <Button onClick={() => setIsShow(true)} variant="primary" style={{ width: "20%" }}>
                Create Accessorial
            </Button>
            <Modal
                size="lg"
                show={isShow}
                onHide={() => setIsShow(false)}
                aria-labelledby="example-modal-sizes-title-md"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-md">
                        Add Accessorial
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={3}>
                            <TextField label="Accessorial Name" {...register('description', { required: 'Field is required' })} error={errors?.description?.message} />
                        </Col>
                        <Col sm={3} >
                            <div className="form-floating">
                                <Form.Select aria-label="Floating label select example" {...register('useFuel', { required: 'Field is required' })}>
                                    <option value="">Select</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </Form.Select>
                                <label htmlFor="accessoial">Use Fuel</label>
                            </div>
                            <p className="error-message">{errors?.useFuel?.message}</p>
                        </Col>
                        <Col sm={3}>
                            <TextField label="Accessorial Code" {...register('accessorialCode', { required: 'Field is required' })} error={errors?.accessorialCode?.message} />
                        </Col>
                        <Col sm={3}>
                            {!isEdit ?
                                <div className="section_action_btn">
                                    <div className="add_btn"><button type="button" className="btn" onClick={handleSubmit(onSubmit)} ><AddCircle /> Add</button></div>
                                </div>
                                :
                                <div className="section_action_btn">
                                    <div className="save_btn"><button type="button" className="btn" onClick={handleSubmit(onSubmit)} ><Save /> Save</button></div>
                                    <div><button type="button" className="btn btn-outline-primary h-100 ms-1" onClick={onCancel} > Cancel</button></div>
                                </div>
                            }
                        </Col>
                    </Row>
                    <div className="user-role-table" style={{ height: "500px" }}>
                        <h6>List of Accessorial</h6>
                        <DataGrid rows={rows} columns={columns} pageSize={15} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};
export default Createaccessorial;
